import { environment } from 'src/environments/environment';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';
import { CombosService } from 'src/app/services/combos.service';
import { SelectList } from 'src/app/models/selectlist';
import { Documentos } from 'src/app/models/documentos';

import { FichaCadastro } from 'src/app/models/ficha-cadastro';
import { Criptografar } from 'src/app/util/criptografar';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit {

  documentoCotistaForm: FormGroup | any;
  docs: FormGroup | any;
  tipoCotista!: string;
  docEnviados: boolean = false;
  habilitarBtnEnviar: boolean = false;
  msgAlert = environment.campoObrigatorio;
  listaRadioIsentoIR!: SelectList[];
  listaRadioDesempregado!: SelectList[];

  public fichaInscricao: FichaCadastro;

  constructor(
    private combosService: CombosService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private uploadDocumentosService : UploadDocumentosService,
    private router: Router,
    private toastr: ToastrService,
    protected utilService: UtilService
  )
  {
    this.fichaInscricao = new FichaCadastro();
  }

  ngOnInit(): void {

    let objCipto : Criptografar = new Criptografar();

    this.fichaInscricao  = JSON.parse(objCipto.decrypt(this.route.snapshot.queryParams['session']));
    this.tipoCotista = this.fichaInscricao.codTpCotista;
    
    this.documentoCotistaForm = new FormGroup({
      indIsentoIR: new FormControl(null, [Validators.required]),
      indDesempregado: new FormControl(null, [Validators.required])
    });

    this.carregaRadioButton();

    if (this.fichaInscricao.ind_alterouTipoCotista){

      this.documentoCotistaForm.controls['indIsentoIR'].setValue(this.fichaInscricao.indIsentoIR);
      this.documentoCotistaForm.controls['indDesempregado'].setValue(this.fichaInscricao.indDesempregado);

      this.carregaUpload();

    }else{
      if (this.fichaInscricao.documentos !== undefined) {
        if (this.fichaInscricao.documentos.length > 0) {
          this.preencheDadosDocumentos(this.fichaInscricao);
        }
      }
    }
  }

  carregaRadioButton() {
    this.listaRadioIsentoIR = this.combosService.getIsentoIR();
    this.listaRadioDesempregado = this.combosService.getDesempregado();
  }

  retornaDocumentosCotista(indIsentoIR: string, indDesempregado: string) {
    this.utilService.showLoading();
      this.uploadDocumentosService.getDocuments(this.tipoCotista, indIsentoIR, indDesempregado)
      .subscribe((documentoCotista: Documentos[]) =>
      {
        this.docs = this.fb.group({
          DocumentoCotista: this.fb.array(documentoCotista.map(
            documento => this.criarDocumento(documento)
          ) || [])
        });
       
        this.validatorsField();
        this.verificaDocumentos();
        this.utilService.showLoading(false);
      },
      error => {
        this.utilService.showLoading(false);
        this.toastr.error(error);
      }
    )
  }

  criarDocumento(docCotista: Documentos) {
    return this.fb.group({
        codDoc: docCotista.codDoc === '' ? Math.random() : docCotista.codDoc,
        descDoc: docCotista.descDoc,
        fileBase64: docCotista.fileBase64,
        nomeArquivo: docCotista.nomeArquivo === '' ? '' : docCotista.nomeArquivo,
        idGed: docCotista.idGed,
        situacao: docCotista.situacao,
        motivoRejeicao: docCotista.motivoRejeicao,
        urlGedDownload: docCotista.urlGedDownload,
        versaoDocGed: 1,
        obrigatorio : docCotista.obrigatorio
    });
  }

  uploadFile(e: any){
    if(e.files[0])
    {
      const indexDocumento = e.index;
      const arquivo = e.files[0];
      const documento: FormGroup = this.obterDocPeloIndex(indexDocumento);
      const descDoc = documento.value.descDoc.substring(0,10);
      const codDoc = documento.value.codDoc;

      if(this.validaTamanhoArquivo(arquivo) && this.validaTipoArquivo(arquivo, descDoc,codDoc))
      {
        var reader = new FileReader();

        reader.readAsBinaryString(arquivo);
        this.showProgress(arquivo);
        reader.onloadend = (event: any) =>
        {
          const binaryString = event.target.result;
          this.inserirString64(documento, binaryString, e);
          this.validatorsField();
        }
      } else {
        e.event.srcElement.value = null;
        documento.patchValue(
          { documento: {
            nomeArquivo: 'Selecione o Arquivo'
        }});
      }
    }
  }

  validaTamanhoArquivo(arquivo: File): boolean{
    if(arquivo.size > 2097152){
      this.toastr.error('Tamanho superior a 2 Megabytes.', 'Arquivo Inválido');
      return false;
    } else  {
      return true;
    }
  }

  validaTipoArquivo(arquivo: File, descDoc: string, codDoc: any): boolean{
      this.toastr.toastrConfig.enableHtml=true;
      
      if (parseInt(codDoc) === 14 || descDoc.toLocaleUpperCase() === 'FOTOGRAFIA') { //FOTO 3 X 4
        if (arquivo.type.toString() !== 'image/jpeg' && arquivo.type.toString() !== 'image/jpg') {
          this.toastr.error('Formato do arquivo não suportado.</br>'
                            +'Somente <b>JPG</b> ou <b>JPEG</b> é suportado.', 'Arquivo Inválido');
          return false;
        }
        else {
              return true;
        }
      }

      switch(arquivo.type) {
        case 'application/pdf':
          return true;
        default:
          this.toastr.error('Formato do arquivo não suportado.</br>Somente <b>PDF</b> é suportado.', 'Arquivo Inválido');
          return false;
      }

  }

  showProgress(arquivo: File){
    this.toastr.info('Carregando', arquivo.name, {
      'extendedTimeOut': 1000,
      'timeOut': 1000,
      'enableHtml': true,
      'tapToDismiss': false,
      'progressBar': true,
      'progressAnimation': 'increasing'
    });
  }

  obterDocPeloIndex(index: number): any {
    let controlArray = <FormArray>this.docs.get('DocumentoCotista');
    return controlArray.at(index);
  }

  inserirString64(doc: any, binaryString: any, e: any){
    doc.patchValue({
      carregandoDocumento: false,
        fileBase64: btoa(binaryString),
        loadSymbol: false,
        nomeArquivo: e.files[0].name
    });
  }

  verificaDocumentos() {
    const docsEnviados = this.docs.get('DocumentoCotista').value.filter((x: { situacao: string; }) => x.situacao === '');
    this.docEnviados = docsEnviados.length === 0
  }

  hasRequired(controlName: string) {
    
    return (
      this.documentoCotistaForm.controls[controlName].errors &&
      (this.documentoCotistaForm.controls[controlName].dirty ||
        this.documentoCotistaForm.controls[controlName].touched)
    );
  }

  validatorsField() {
    const result = this.docs.get('DocumentoCotista').value as Array<Documentos>;
    this.habilitarBtnEnviar = true;

    if (result.length > 0){
      
      //this.habilitarBtnEnviar = result.every(doc => doc.fileBase64 != '' && doc.fileBase64 != undefined && doc.obrigatorio==true)

      this.docs.get('DocumentoCotista').controls.forEach((group: FormGroup<any>) => {

        let controle = group.get('fileBase64') as FormControl;
        let DocObrigatorio = group.get('obrigatorio') as FormControl;

        //if(!this.habilitarBtnEnviar && DocObrigatorio.value == true && controle.value == ''){
        if(DocObrigatorio.value == true && (controle.value == '' || controle == undefined)){
          controle.setValidators([Validators.required]);
          controle.updateValueAndValidity();
          this.habilitarBtnEnviar = false;
        } 
        else{
          controle.setValidators([]);
          controle.updateValueAndValidity();
        }
      });

    } else {
      this.habilitarBtnEnviar = false;
    }
  }

  habilitaBtnAvancar() {
    return (!this.documentoCotistaForm.valid || !this.habilitarBtnEnviar)
  }

  avancar(){
      this.addValueObjectFichaInscricao();
      let objCripto: Criptografar = new Criptografar();
      let strAcesso = objCripto.encrypt(JSON.stringify(this.fichaInscricao));
      this.fichaInscricao.ind_alterouTipoCotista=false;
      if(this.fichaInscricao.cotista === true){
          this.router.navigate(['/confirmacaoinscricao'], {
          queryParams: { session: strAcesso },
        });
      }
  }

  preencheDadosDocumentos(formRetorno: any) {
 
    this.documentoCotistaForm.controls['indIsentoIR'].setValue(formRetorno.indIsentoIR);
    this.documentoCotistaForm.controls['indDesempregado'].setValue(formRetorno.indDesempregado);

    this.docs = this.fb.group({
      DocumentoCotista: this.fb.array(
        formRetorno.documentos.map((documento: any) =>
          this.criarDocumento(documento)
        ) || []
      ),
    });
  
    this.validatorsField();
  }

  carregaUpload() {    
    let indIsentoIR = this.documentoCotistaForm.controls['indIsentoIR'].value;
    let indDesempregado = this.documentoCotistaForm.controls['indDesempregado'].value;
    
    if (indIsentoIR !== null && indDesempregado !== null) {
      this.retornaDocumentosCotista(indIsentoIR, indDesempregado);
    }
  }

  btnRetornarTelaAnterior() {
    this.addValueObjectFichaInscricao();
    let objCripto: Criptografar = new Criptografar();
    this.fichaInscricao.ind_alterouTipoCotista=false;
    let strAcesso = objCripto.encrypt(JSON.stringify(this.fichaInscricao));
    this.router.navigate(['/fichainscricao'], { queryParams: { session: strAcesso } });
  }

  addValueObjectFichaInscricao() {
    let indIsentoIR = this.documentoCotistaForm.controls['indIsentoIR'].value;
    let indDesempregado = this.documentoCotistaForm.controls['indDesempregado'].value;

    if (indIsentoIR != null && indDesempregado != null) {
      this.fichaInscricao.indIsentoIR  = indIsentoIR;
      this.fichaInscricao.indDesempregado = indDesempregado;
      this.fichaInscricao.documentos = this.docs.controls['DocumentoCotista'].value;
    }
  }

}
